module.exports = __webpack_public_path__ + "static/media/login_logo.8a93b945.svg";